<template>
  <div class="page-header level">
    <div class="level-left">
      <div class='size1-text pri-color'>Exception Report ({{cycleDate}})</div>
    </div>
    <div class="level-right">
      <span class="page-heading-label">Total Outstanding Billing</span>
      <span class="page-heading-total-amount app-green">
        {{totalCurrentAmtDueFormatted}}
      </span>
    </div>
  </div>
  <div class="level status-message" v-if="statusMessage && statusMessage.length > 0">
    <div class="level-item">{{statusMessage}}</div>
  </div>

  <div class="level">
    <div class="level-left">
      <div class="page-heading-label level-item">
          Per Page:
      </div>
      <div class="level-item">
        <select v-on:change="onPageSizeChanged()" id="page-size">
            <option value="10" selected="">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="200">200</option>
        </select>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <button id="export-button" v-on:click="onBtExport()" class="button is-secondary">
          Export to CSV
        </button>
      </div>
    </div>
  </div>
  <ag-grid-vue
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      id="myGrid"
      rowSelection="multiple"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :columnDefs="columnDefs"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :defaultColDef="defaultColDef"
      :modules="modules"
      :rowData="rowData">
  </ag-grid-vue>

  <div class="level bulk-action-wrapper">
    <div class="level-left">
      <div class="level-item">
        <div class="page-heading-label">
          Actions:
        </div>
        <div v-on:click="onBtRetryPayments()" class="button is-secondary bulk-action-btn">
          Re-Run Card(s)
        </div>
        <div v-on:click="onBtResendDocuments()" class="button is-secondary bulk-action-btn">
          Resend Invoice(s)
        </div>
      </div>
    </div>
  </div>

  <add-note
    :userId="selectedCustId"
    :businessName="selectedBusinessName"
    :showModal="showAddNote"
    @saved="saveNoteClicked"
    @cancelled="cancelAddNoteClicked">
  </add-note>
  <PageLoading :showLoading="!isReady"></PageLoading>
</template>
<script>
import { AgGridVue } from 'ag-grid-vue3';
import { AllCommunityModules } from 'ag-grid-community';
import MoneyUtils from '@/shared/money-utils';
import billData from '@/services/bill-data';
import paidPreparerData from '@/services/paid-preparer-data';
import AddNote from '@/components/add-note.vue';
import PageLoading from '@/components/page-loading.vue';
import GridUtils from '@/shared/grid-utils';

window.currencyFormatter = function currencyFormatter(params) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(params.value);
};
window.phoneFormatter = function phoneFormatter(params) {
  const str = params.value;
  // Filter only numbers from the input
  // eslint-disable-next-line prefer-template
  const cleaned = ('' + str).replace(/\D/g, '');

  // Check if the input is of correct
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // Remove the matched extension code
    // Change this to format for any country code.
    const intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return null;
};

export default {
  name: 'ExceptionReport',
  components: { AgGridVue, AddNote, PageLoading },
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      modules: AllCommunityModules,
      rowData: null,
      paginationPageSize: null,
      totalOustandingBilling: 0,
      cycleDate: '',
      statusMessage: '',
      activeBillStatusId: -1,
      suspendedBillStatusId: -2,
      closedBillStatusId: -3,
      showAddNote: false,
      selectedCustId: '',
      selectedBusinessName: '',
      isReady: false,
    };
  },
  mixins: [MoneyUtils, GridUtils],
  methods: {
    getSelectedRowData() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map((node) => node.data);
      // eslint-disable-next-line no-alert
      alert(`Selected Nodes:\n${JSON.stringify(selectedData)}`);
      return selectedData;
    },

    async fetchGridData() {
      this.isReady = false;
      await this.$store.dispatch('billCycles/fetchPaymentExceptions');
      console.log('store data');
      this.cycleDate = this.$store.state.billCycles.paymentExceptions.billCycle;
      this.rowData = this.$store.state.billCycles.paymentExceptions.data;
      this.computeTotalDue();
      this.isReady = true;
    },
    computeTotalDue() {
      if (!this.rowData || this.rowData.length === 0) {
        this.rowData = [];
      }
      let totalAmtDue = 0;
      this.rowData.forEach((row) => {
        totalAmtDue += (+row.TotalAmount);
      });
      this.totalOustandingBilling = totalAmtDue;
    },
    async onGridReady() {
      await this.fetchGridData();
    },
    onBtExport() {
      const expParams = {
        columnKeys: ['BusinessName', 'ContactName', 'BusinessPhone', 'TotalAmount', 'Status', 'ErrorMessage'],
      };

      this.gridApi.exportDataAsCsv(expParams);
      // unfortunately, you need a commercial license of ag grid for this one.
      //      this.gridApi.exportDataAsExcel();
    },
    async onBtRetryPayments() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedRecs = selectedNodes.map((node) => ({ userId: node.data.UserID }));
      const res = await billData.methods.retryPayments(selectedRecs);
      if (res.criticalError > 0) {
        this.statusMessage = `There was an unanticipated problem in processing your request.  Please contact the IT administrator critical errors: ${res.criticalError}`;
      } else {
        this.statusMessage = `Your request to retry the payment method on file for ${selectedRecs.length} user(s) has been submitted!`;
      }
      setTimeout(() => {
        this.statusMessage = '';
      }, 4000);
      // return selectedData;
    },
    findCurrentRow(userId) {
      let row = {};
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.rowData.length; i++) {
        const sRow = this.rowData[i];
        if (sRow.UserID === userId) {
          row = sRow;
          break;
        }
      }
      return row;
    },
    async onBtResendDocuments() {
      console.log('The resend document button was clicked!');
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedRecs = selectedNodes.map((node) => ({ userId: node.data.UserID, docType: 'invoice' }));
      const res = await billData.methods.resendDocuments(selectedRecs);
      if (res.criticalError > 0) {
        this.statusMessage = `There was an unanticipated problem in processing your request.  Please contact the IT administrator critical errors: ${res.criticalError}`;
      } else {
        this.statusMessage = `Your request to resend the most recent invoice to ${selectedRecs.length} user(s) has been submitted!`;
      }
      setTimeout(() => {
        this.statusMessage = '';
      }, 4000);
      // return selectedData;
    },
    onPageSizeChanged() {
      const ps = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(ps));
    },
    async onToggleBillStatus(userId, currentStatus) {
      console.log(`on toggle bill status fired ${userId} ${currentStatus}`);
      const billStatusId = currentStatus === 'Suspended' ? this.closedBillStatusId : this.suspendedBillStatusId;
      const payload = { billStatusId };
      await paidPreparerData.methods.updateBillStatusForPP(userId, payload);
      return currentStatus === 'Suspended' ? 'Closed' : 'Suspended';
    },
    async saveNoteClicked() {
      console.log('save add note clicked!');
      this.showAddNote = false;
    },
    cancelAddNoteClicked() {
      console.log('cancel add note clicked');
      this.showAddNote = false;
    },
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        field: 'InvoiceNumber',
        editable: true,
        headerName: 'Invoice #',
        minWidth: 125,
        maxWidth: 140,
      },
      {
        field: 'BusinessName',
        editable: true,
        minWidth: 250,
      },
      {
        field: 'ContactName',
        editable: true,
        headerName: 'Contact',
      },
      {
        field: 'BusinessPhone',
        headerName: 'Bus Phone',
        editable: true,
        minWidth: 160,
        // eslint-disable-next-line no-undef
        valueFormatter: phoneFormatter,
      },
      {
        field: 'TotalAmount',
        headerName: 'Balance',
        editable: true,
        filter: 'agNumberColumnFilter',
        filterParams: GridUtils.numberFilterParams,
        minWidth: 110,
        maxWidth: 125,
        // eslint-disable-next-line no-undef
        valueFormatter: currencyFormatter,
      },
      {
        field: 'Status',
        editable: true,
        headerName: 'Status',
        maxWidth: 110,
        cellRenderer: (params) => {
          const wrap = document.createElement('div');
          wrap.innerHTML = `${params.value}`;
          if (params.value === 'Closed') {
            wrap.classList.add('is-closed');
            document.styleSheets[0].insertRule('.is-closed { color: #D21515; }', 0);
          }
          return wrap;
        },
      },
      {
        field: 'ErrorMessage',
        headerName: 'Balance Rejection Info',
        editable: true,
        minWidth: 250,
      },
      {
        field: 'UserID',
        headerName: '',
        sortable: false,
        filter: false,
        minWidth: 250,
        cellRenderer: (params) => {
          const wrap = document.createElement('div');

          const sep = document.createElement('span');
          sep.innerText = ' | ';

          const sep2 = document.createElement('span');
          sep2.innerText = ' | ';

          const route = {
            name: 'customer-detail',
            params: { id: params.data.UserID, returnTo: 'exception-report' },
          };
          const dlink = document.createElement('a');
          dlink.href = this.$router.resolve(route).href;
          dlink.innerText = 'View Details';
          dlink.addEventListener('click', (e) => {
            e.preventDefault();
            this.$router.push(route);
          });

          const closeLink = document.createElement('a');
          closeLink.setAttribute('id', `billStatus-${params.data.UserID}`);
          closeLink.href = '#';
          // console.log('Params are: ');
          // console.log(params.data.status);
          closeLink.innerText = params.data.Status === 'Closed' ? 'Suspend' : 'Close';
          closeLink.addEventListener('click', async (e) => {
            e.preventDefault();
            console.log('Here is is XXXXXXXXXXXX CLOSE XXXXXXXXXXXXXX:');
            console.log(params);
            console.log(e);
            const newStatus = await this.onToggleBillStatus(params.data.UserID, params.data.Status);
            console.log(newStatus);
            const linkText = newStatus === 'Closed' ? 'Suspend' : 'Close';
            const link = document.getElementById(`billStatus-${params.data.UserID}`);
            link.innerText = linkText;
            // params.node.setDataValue('businessName', `${params.data.businessName} `);
            console.log('before and after status update.');
            console.log(this.rowData);
            const data = this.findCurrentRow(params.data.UserID);
            data.status = newStatus;
            params.node.setDataValue('Status', newStatus);
            console.log(this.rowData);
          });

          const addNoteLink = document.createElement('a');
          addNoteLink.href = '#';
          addNoteLink.innerText = 'Add Note';
          addNoteLink.addEventListener('click', async (e) => {
            e.preventDefault();
            this.selectedCustId = params.data.UserID;
            this.selectedBusinessName = params.data.BusinessName;
            this.showAddNote = true;
          });

          wrap.appendChild(closeLink);
          wrap.appendChild(sep);
          wrap.appendChild(addNoteLink);
          wrap.appendChild(sep2);
          wrap.appendChild(dlink);

          return wrap;
        },
      },
    ];
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 50,
      filter: 'agTextColumnFilter',
      filterParams: GridUtils.textFilterParams,
      resizable: true,
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  async created() {
    await this.$store.dispatch('pickLists/fetchBillStatuses');
    const bs = this.$store.state.pickLists.billingStatuses.statuses;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < bs.length; i++) {
      const item = bs[i];
      if (item.Status === 'Closed') this.closedBillStatusId = item.BillingStatusID;
      if (item.Status === 'Suspended') this.suspendedBillStatusId = item.BillingStatusID;
    }
  },
  computed: {
    totalCurrentAmtDueFormatted() {
      return this.formatAsMoney(this.totalOustandingBilling);
    },
  },
  props: {
    msg: String,
  },
};
</script>
<style src='ag-grid-community/dist/styles/ag-theme-alpine.css'></style>
<style src='ag-grid-community/dist/styles/ag-grid.css'></style>
<style lang="scss" scoped>
    #export-button {
        font-weight: bold;
    }
    .status-message {
      background-color: green;
      color: #fff;
      min-height: 50px;
    }

@import "~ag-grid-community/src/styles/ag-grid.scss";
@import "~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin";
.ag-theme-alpine {
    @include ag-theme-alpine((
        // use theme parameters where possible
        header-foreground-color: #FFF,
        header-background-color: #0F3D80,
        font-family: ('Helvetica', 'Arial', 'sans-serif'),
    ));

    .ag-icon {
      color: #FFF;
    }
    .ag-paging-button > .ag-icon {
        color: #000;
    }
    .ag-header-cell-text {
      font-size: 14px;
    }
}
  .pb-container {
    display: flex;
    justify-content: space-between;
  }
  .ipb-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tb {
    padding-left: 10px;
  }
  .tr {
    padding-left: 20px;
  }
  .pause-btn-toggle {
    min-width: 153px;
  }
  .bulk-action-wrapper {
    margin-top: 20px;
  }
  .bulk-action-btn {
    margin-left: 12px;
    font-weight: bold;
  }
  .page-heading-label {
      font-weight: 600;
      margin-top: 10px;
      line-height: 1.75;
      text-align: right;
      min-width: 0px;
      margin-bottom: 5px;
  }
  .page-heading-total-amount {
    margin-left: 10px;
  }
</style>
